import styled from 'styled-components';

export const ActionButton = styled.button`
  width: 100%;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 12px;
  background: #d8eaf9;
  margin-top: 1.2rem;
  gap: 0.8rem;
  p {
    color: #1672ba;
    letter-spacing: -0.42px;
    width: 9.3rem;
  }
`;
